var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_10358)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#paint0_linear_14_10358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.993 170.571C641.366 139.496 552.385 43.9093 528.598 0H0V1080H1171.73C1344.4 390.962 1014.03 209.414 806.993 170.571Z",
    fill: "url(#paint1_linear_14_10358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.661 193.824C329.256 122.727 299.324 34.9843 317.283 0H0V1080H1010.86C1037.54 1022.45 1064.74 838.777 1075 754.138C1064.74 335.172 921.917 282.696 592.661 193.824Z",
    fill: "url(#paint2_linear_14_10358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1686 118C1469 118 1452.73 40.7882 1448 0H1920V1080C1912.12 1054.82 1896.37 938.27 1896.37 673.537C1896.37 333 1863.72 118 1686 118Z",
    fill: "url(#paint3_linear_14_10358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.5 70.5C1585.5 60.1 1552.5 19.1667 1549 0H1920V507.5C1914.17 495.667 1902.5 440.9 1902.5 316.5C1902.5 161 1819.5 83.5 1689.5 70.5Z",
    fill: "url(#paint4_linear_14_10358)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_10358",
    x1: 1907.5,
    y1: 0.000140864,
    x2: -0.000109523,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_10358",
    x1: 610,
    y1: 0,
    x2: 610,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_10358",
    x1: 492.5,
    y1: -7.37463e-7,
    x2: 537.5,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_10358",
    x1: 1669.5,
    y1: 0,
    x2: 1669.5,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BAFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_10358",
    x1: 1734.5,
    y1: 0,
    x2: 1734.5,
    y2: 507.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BAFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_10358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login_bg.4b8ff3ae48d41fc5d47d03a3a0aac6ff.svg";
export { ForwardRef as ReactComponent };